module.exports = __webpack_public_path__ + "img/notes_001.f006c38e.png";